import { map, path } from 'ramda';
import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { applyFormatter, isDefined } from '@bridebook/web/app-shared/lib/supplier/formatters';

// check if item name has corresponding data in object
const itemsDefined = (items: string[], obj: ISupplier): Array<boolean> =>
  map((item) => isDefined(applyFormatter(item, path(item.split('.'))(obj))), items);

export default itemsDefined;
